import React from 'react';
import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useQuery } from '@apollo/client';

import { GET_REQUEST_ESCALATION_MESSAGE } from '../../apollo/queries/priceChangeRequest';

type Props = {
    requestId: string | null;
};

function EscalatedRequest({ requestId }: Props) {
    const {
        data: messageData,
        loading,
        error,
    } = useQuery(GET_REQUEST_ESCALATION_MESSAGE, {
        variables: {
            id: requestId,
        },
        skip: !requestId,
        fetchPolicy: 'network-only',
    });

    if (
        !requestId ||
        !messageData ||
        loading ||
        error ||
        !messageData.getPriceChangeRequestEscalated ||
        !messageData.getPriceChangeRequestEscalated.message ||
        !messageData.getPriceChangeRequestEscalated.message.includes(
            'This action has been escalated to you',
        )
    ) {
        return null;
    }

    return (
        <Alert
            icon={<IconAlertCircle size="1rem" />}
            title="Escalated"
            color="red"
            className="mb-5"
            radius="md"
        >
            {messageData.getPriceChangeRequestEscalated.message}
        </Alert>
    );
}

export default EscalatedRequest;
